"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorOrRescheduledStates = exports.CANCEL_ROUTE = void 0;
const _1 = require("./");
exports.CANCEL_ROUTE = '/cancel';
// These states include both error states and the final appointment rescheduled states.
// There is a slight difference in design for these pages in mobile view.
exports.errorOrRescheduledStates = [
    _1.states.appointmentRescheduled,
    _1.states.alreadyCanceled,
    _1.states.modificationWindowExpired,
    _1.states.alreadyRescheduled,
    _1.states.disabled,
    `${_1.states.newSearch}.${_1.states.failedFetchingslots}`,
    _1.states.appointmentMissed,
    _1.states.canceledPreviously,
    _1.states.confirmationPage
];
//# sourceMappingURL=configs.js.map